export interface Social {
  name: string;
  color?: string;
  url: string;
}

export const socialLinks: Array<Social> = [
  {
    name: "facebook",
    color: "#1877F2",
    url: "https://www.facebook.com/igusti.murniati.1",
  },
  {
    name: "instagram",
    color: "#E4405F",
    url: "https://www.instagram.com/ayunibambu0404/",
  },
  {
    name: "tiktok",
    color: "#000000",
    url: "https://www.tiktok.com/@aadcbambu",
  },
  {
    name: "github",
    color: "#181717",
    url: "https://github.com/natainditama/aadc-bambu",
  },
];
